import { render, staticRenderFns } from "./MatStart.vue?vue&type=template&id=3d33b41b&scoped=true"
import script from "./MatStart.vue?vue&type=script&lang=js"
export * from "./MatStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33b41b",
  null
  
)

export default component.exports